/**
 * Gets the display value from either a translation object or a plain string
 * Prioritizes the 'en' value when it's an object
 *
 * @param {object | string} value - The value to get the display text from
 * @returns {string} - The display string
 */
export function getDisplayValue(value) {
  // If the value is not an object or is null/undefined, return it as is
  if (!value || typeof value !== 'object') {
    return value
  }

  // If it's an object, prioritize the 'en' value
  if (value.en) {
    return value.en
  }

  // If no 'en' value, return the first available
  const firstKey = Object.keys(value)[0]
  if (firstKey) {
    return value[firstKey]
  }

  // If all else fails, return empty string
  return ''
}

/**
 * Prepares a value for saving to the API
 * Ensures we only save the string value or 'en' property
 *
 * @param {object | string} value - The value to prepare for saving
 * @returns {string} - The value ready for API
 */
export function prepareValueForSave(value) {
  // If it's already a string, convert it to an object with the 'en' key
  if (typeof value === 'string') {
    return { en: value }
  }

  // If it's an object, ensure it has the proper structure
  if (value && typeof value === 'object') {
    // If it has language keys (like 'en'), keep it as is
    if (value.en !== undefined) {
      return value
    }

    // If it's an object but doesn't have language keys, try to extract a value
    const firstKey = Object.keys(value)[0]
    if (firstKey) {
      return { en: value[firstKey] }
    }
  }

  // For empty or null values, return an object with empty string
  return { en: '' }
}
